import PaymentWrapper from './PaymentWrapper';

export default PaymentWrapper;
